import { render, staticRenderFns } from "./Payment-Analysis.vue?vue&type=template&id=96f64d12&"
import script from "./Payment-Analysis.vue?vue&type=script&lang=js&"
export * from "./Payment-Analysis.vue?vue&type=script&lang=js&"
import style0 from "./Payment-Analysis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports